module.exports = __webpack_public_path__ + "public/img/vipbanka.1dcccea9.png";